import React from 'react';
import { RefreshCw, UserPlus } from 'lucide-react';
import { Button } from '../ui/Button';
import { Banner } from '../ui/Banner';
import { DjayNarrator } from '../../mascot';
interface DemoBannerProps {
  onResetDemo: () => void;
  onRegister: () => void;
}
const DjayIcon = ({
  className
}: {
  className?: string;
}) => <div className={`shrink-0 bg-white/60 rounded-full p-1 shadow-sm border border-amber-200/50 ${className}`} data-id="element-2373" data-mp="tepcy8v63icy">
    <DjayNarrator size="xs" emotion="pointing" animate={false} data-id="element-2374" data-mp="1q3etnvv264xc" />
  </div>;
export function DemoBanner({
  onResetDemo,
  onRegister
}: DemoBannerProps) {
  return <Banner variant="warning" icon={DjayIcon} title="DEMO MODUS" className="z-50 relative rounded-none sm:rounded-none border-x-0 border-t-0" action={<div className="flex items-center gap-2 w-full sm:w-auto" data-id="element-2376" data-mp="5o3cp3ren2di">
          <Button variant="ghost" size="sm" onClick={onResetDemo} className="flex-1 sm:flex-none text-amber-800 hover:bg-amber-200/50 hover:text-amber-900" data-id="element-2377" data-mp="5pegh3kuoa4m">
            <RefreshCw className="w-4 h-4 mr-1.5" data-id="element-2378" data-mp="2vmn79nwaoye5" />
            Reset
          </Button>
          <Button variant="danger" size="sm" onClick={onRegister} className="flex-1 sm:flex-none shadow-sm" data-id="element-2379" data-mp="30lgi18k76bam">
            <UserPlus className="w-4 h-4 mr-1.5" data-id="element-2380" data-mp="2rljoasiyam8p" />
            Account maken
          </Button>
        </div>} data-id="element-2375" data-mp="1h2qq5v3ajmyp">
      <span className="opacity-90" data-id="element-2381" data-mp="2cwnkx8ru9xef">Je verkent de app met voorbeelddata</span>
    </Banner>;
}